import { type MutationError, trpc } from '@/shared/api';

interface Options {
  readonly onSuccess?: () => void;
}

/** 템플릿 이름·카테고리 지정 변경. */
export const useUpdateEditAreaTemplate = ({ onSuccess }: Options = {}) => {
  const mutation = trpc.productManagement.editAreaTemplates.update.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    updateTemplate: mutation.mutate,
    isPending: mutation.isPending,
    error,
    reset: mutation.reset,
  };
};
